module.exports = "https://cdn-challenge.mathletics.com/app/299/assets/images/ef5edcf1ceffd976fa22a0d04a097976.svg";